import {getWidthHeight} from '@/services/utility.js';
import {faClose} from '@fortawesome/free-solid-svg-icons';
import {useTheme} from 'styled-components';
import translator from '../../translator/common.js';
import {
  CommonButton,
  CommonWebBox,
  MyView,
  PhoneView,
} from '../CommonComponents.jsx';
import vars from '../root';
import {styles} from './styles.js';
import {TextIcon} from './TextIcon.jsx';
const width = getWidthHeight()[0];
const modal = {
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: 'rgba(230,230,230,0.8)',
    height: '100vh',
    top: 0,
    left: 0,
    width: '100%',
    position: 'fixed',
    zIndex: 20,
  },
  box: {
    position: 'absolute',
    left: width > 768 ? 30 : 10,
    right: width > 768 ? vars.RIGHT_MENU_WIDTH : 10,
    top: 90,
    maxHeight: 'calc(100vh - 150px)',
    overflow: 'auto',
  },
  marginBottom20: {
    marginBottom: 20,
  },
  padding0: {
    padding: 0,
  },
  padding5and30: {
    padding: '5px 30px',
  },
};
export function LargePopUp(props) {
  const theme = useTheme();
  return (
    <MyView style={modal.container}>
      <CommonWebBox
        header={props.header}
        btn={
          props.toggleShowPopUp ? (
            <TextIcon
              style={{
                ...modal.marginBottom20,
                ...modal.padding0,
                // position: 'sticky',
                // top: 10,
              }}
              onPress={() => props.toggleShowPopUp()}
              text={props.title}
              icon={faClose}
            />
          ) : undefined
        }
        style={{...modal.box, backgroundColor: theme.colors.base_200}}
        child={
          <MyView style={{padding: '10px'}}>
            {props.toggleShowPopUp && !props.header && (
              <TextIcon
                style={{
                  ...modal.marginBottom20,
                  ...modal.padding0,
                  // position: 'sticky',
                  // top: 10,
                  // zIndex: 99,
                  // backgroundColor: theme.colors.background.primary,
                }}
                onPress={() => props.toggleShowPopUp()}
                text={props.title}
                icon={faClose}
              />
            )}
            {props.children}
            <PhoneView
              style={{
                ...styles.marginTop20,
              }}>
              {props.btns}
              {(props.removeCancel === undefined || !props.removeCancel) && (
                <CommonButton
                  style={{
                    ...modal.padding5and30,
                  }}
                  onPress={() => props.toggleShowPopUp()}
                  title={translator.cancel}
                />
              )}
            </PhoneView>
          </MyView>
        }
      />
    </MyView>
  );
}
